<template>
  <div class="courseList">
    <div
        v-for="(course, index) in list"
        :key="index"
        class="course-item row"
        :class="{
          'selected': course.status === 'watching'
        }"
        @click="$emit('selectVideo', index)"
    >
      <div class="status">
        <IconStatus :status="course.status"/>
      </div>
      <div class="column">
        <div class="subTitle">
          Lesson {{index + 1}}
        </div>
        <div class="name">
          {{ course.name }}
        </div>
      </div>
      <div class="like" @click.stop="$emit('like', index)">
        <IconLike :liked="course.liked"/>
      </div>
    </div>
  </div>
</template>

<script>
import IconLike from "@/components/market/icons/IconLike";
import IconStatus from "@/components/market/icons/IconStatus";
export default {
  name: "CourseList",
  components: {IconLike, IconStatus},
  props: {
    list: Array
  }
}
</script>

<style scoped lang="scss">
.courseList {
  .course-item {
    cursor: pointer;
    background-color: #FEFEFE;
    padding: 10px 10px 10px 20px;
    align-items: center;
    &.selected {
      background: rgba(158, 195, 96, 0.1);
      .subTitle {
        color: #9EC360;
      }
    }
    .status {
      margin-right: 15px;
    }
    .like {
      margin-left: auto;
    }
    .title {
      font-size: 16px;
      color: #3B3B3B;
    }
    .subTitle {
      font-weight: bold;
      font-size: 10px;
      line-height: 12px;
      color: #BDBDBD;
      margin-bottom: 10px;
    }
  }
  .row {
    display: flex;
  }
  .column {
    display: flex;
    flex-direction: column;
  }
}
</style>